export const CinematicBackdrop = ({ opacity = 0.16 }) => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="cinematic-backdrop">
    <video
      autoPlay
      muted
      loop
      playsInline
      poster="/videos/backdrop_poster.jpg"
      className="w-full h-full object-cover grayscale"
      style={{ opacity }}
    >
      <source src="/videos/backdrop.mp4" type="video/mp4" />
    </video>
    <div className="absolute inset-0 bg-gradient-to-b from-[#FFFFFF]/70 via-[#FFFFFF]/85 to-[#FFFFFF]" />
  </div>
);
